export enum ErrorType {
  SYSTEM_ERROR = 'SYSTEM_ERROR',
  PAYMENT_ERROR = 'PAYMENT_ERROR',
  UNKNOWN = 'UNKNOWN',
  STANDALONE_AUTOPAY_ERROR = 'STANDALONE_AUTOPAY_ERROR',
  AUTOPAY_ALREADY_ENROLLED = 'AUTOPAY_ALREADY_ENROLLED',
  INELIGIBLE_FOR_AUTOPAY = 'INELIGIBLE_FOR_AUTOPAY',
  PAYMENT_IN_PROCESSING = 'PAYMENT_IN_PROCESSING',
  BOT_ERROR = 'BOT_ERROR',
}

export interface Error {
  errorMessage: string;
  errorType: ErrorType;
}
